import { Tooltip, Button } from '@spotted-zebra-uk/ui-components';
import Icon from 'components/atoms/Icon';
import { ProjectJobDescriptionProcessingStatus } from 'generated/graphql';
import styles from './JobDescriptionValue.module.scss';

const MAX_FILE_NAME_LENGTH = 45;

type DownloadProps = {
  jobDescriptionProcessingStatus:
    | ProjectJobDescriptionProcessingStatus
    | null
    | undefined;
  onClick: () => void;
  loading: boolean;
};

const JobDescriptionValue = ({
  fileName,
  jobDescriptionProcessingStatus,
  onClick,
  loading,
}: { fileName: string } & DownloadProps) => {
  return (
    <div className={styles.jobDescriptionValue}>
      <FormattedJobDescriptionFileName fileName={fileName} />
      <JobDescriptionDownloadButton
        jobDescriptionProcessingStatus={jobDescriptionProcessingStatus}
        onClick={onClick}
        loading={loading}
      />
    </div>
  );
};

export default JobDescriptionValue;

const FormattedJobDescriptionFileName = ({
  fileName,
}: {
  fileName: string;
}) => {
  if (fileName.length > MAX_FILE_NAME_LENGTH) {
    return (
      <Tooltip
        content={fileName}
        className={styles.formattedJobDescriptionFileNameTooltip}
      >
        <span className={styles.formattedJobDescriptionFileName}>
          {fileName.substring(0, MAX_FILE_NAME_LENGTH)}...
        </span>
      </Tooltip>
    );
  }
  return (
    <span className={styles.formattedJobDescriptionFileName}>{fileName}</span>
  );
};

const JobDescriptionDownloadButton = ({
  jobDescriptionProcessingStatus,
  onClick,
  loading,
}: DownloadProps) => {
  const isReady =
    jobDescriptionProcessingStatus ===
    ProjectJobDescriptionProcessingStatus.Processed;

  const notReadyTooltip =
    jobDescriptionProcessingStatus ===
    ProjectJobDescriptionProcessingStatus.Failed
      ? 'Job description failed to process'
      : 'Job description is being processed';

  const button = (
    <Button
      size="small"
      variant="tertiary"
      leftIcon={<Icon icon="small_download" />}
      loading={loading}
      disabled={!isReady || loading}
      onClick={isReady ? onClick : undefined}
      data-testid="project-info__job-description-download-button"
    >
      Download
    </Button>
  );

  return isReady ? (
    button
  ) : (
    <Tooltip content={notReadyTooltip}>{button}</Tooltip>
  );
};
